module.exports = __webpack_public_path__ + "img/3_de.bfd9f406.webp";